export interface CommunitySettingsData {
  opciones: {
    permitirComentarios: boolean;
    permitirReacciones: boolean;
    permitirCompartir: boolean;
    permitirSeguidores: boolean;
  };
  privacidad: 'publica' | 'registrados';
  notificaciones: {
    nuevosSeguidores: boolean;
    nuevosComentarios: boolean;
    mensajesCabina: boolean;
  };
}

export const defaultCommunitySettings: CommunitySettingsData = {
  opciones: {
    permitirComentarios: true,
    permitirReacciones: true,
    permitirCompartir: true,
    permitirSeguidores: true,
  },
  privacidad: 'publica',
  notificaciones: {
    nuevosSeguidores: true,
    nuevosComentarios: false,
    mensajesCabina: true,
  },
};